import * as React from "react";
import {
  Text,
  View,
  TextInput,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
} from "react-native";
import GlobalStyles from "../../components/GlobalStyles.js";
import StepBackButtonTopWhite from "../../components/StepBackButtonTopWhite";
import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import Colors from "../../utilities/Color.js";
import { Layout, Select, SelectItem } from "@ui-kitten/components";
import CustomIcon from "../../components/CustomIcon";
import { addCard, getBanks } from "../../redux/actions/CardActions";
import { normalizeUnits } from "moment";

const key = 'dIytaQwWX8UWQEx4VF5dHGwO04D5FP1D';
const iv = '\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0';

const encrypt = (text) => {
  const CryptoJS = require("crypto-js");
  var words = CryptoJS.enc.Utf8.parse(text);
  var keywords = CryptoJS.enc.Utf8.parse(key);
  var ivwords = CryptoJS.enc.Utf8.parse(iv);

  let encrypted = CryptoJS.AES.encrypt(words, keywords, { iv: ivwords });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}

export default function CardsAddNewScreen() {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [selectedID, setSelectedID] = React.useState(1);

  const [cardNo, setCardNo] = React.useState("");
  const [expiry, setExpiry] = React.useState("");

  const [cardNoErrorMessage, setCardNoError] = React.useState("");
  const [dateErrorMessage, setDateError] = React.useState("");

  const banks = useSelector((state) => state.card.banks);
  const banksLoaded = useSelector((state) => state.card.banksLoaded);
  const ErrMessage = useSelector((state) => state.card.cardError) || "";
  const navigation = useNavigation();

  const [formSubmission, setSubmit] = React.useState(false);

  function submitForm() {
    if (formSubmission)
      return;
    const valid = require("card-validator");
    var numberValidation = valid.number(cardNo);
    var dateValidation = valid.expirationDate(expiry);

    if( !numberValidation.isPotentiallyValid || 
        !numberValidation.isValid || 
        !dateValidation.isPotentiallyValid || 
        !dateValidation.isValid) {
          // not guaranteed valid - we should bail
          return;
    }

    var trimmedCard = cardNo.replace(/\s/g, "");
    var trimmedDate = dateValidation.month.concat(dateValidation.year.slice(-2));

    // console.log(encrypt(cardNo.concat(expiry)));
      var data = `{
        "data":"${encrypt(trimmedCard.concat(trimmedDate))}",
        "bankCode":${selectedID},
        "isDefault": true
      }`;
      // console.log(encrypt(cardNo.concat(expiry)));
      // console.log(encryptAlt(cardNo.concat(expiry)));
      let succeeded = addCard(data);
      setSubmit(true);
      // if (succeeded) {
      //   navigation.navigate("CardsHome");
      // } else {
      //   navigation.navigate("CardsAddError");
      // }
  }

  function handleUpdateCardText(text) {
    const valid = require("card-validator");
    var numberValidation = valid.number(text);

    if(!numberValidation.isPotentiallyValid) {
      // render some kind of error message
      setCardNoError("This card number appears invalid.");
    } else {
      setCardNoError("");
      if(numberValidation.card != null) {
        if(numberValidation.card.type != 'visa' && numberValidation.card.type != 'mastercard') {
          setCardNoError("Currently we only accept Mastercard or Visa card.");
        }
      }
    }

    if (cardNo.length > text.length) {
      setCardNo(text);
      return;
    }

    setCardNo(text.replace(/\W/gi, '')
                  .replace(/(.{4})/g, '$1 ')
                  .substring(0, 19));
  }

  function handleUpdateExpiryText(text) {
    const valid = require("card-validator");
    var dateValidation = valid.expirationDate(text);
  
    if(!dateValidation.isPotentiallyValid) {
      // render some kind of error message
      setDateError("This expiry date appears invalid.");
    } else {
      setDateError("");
    }

    if (expiry.length > text.length) {
      setExpiry(text);
      return;
    }

    setExpiry(text.replace(/\W/gi, '')
                  .replace(/(.{2})/g, '$1/')
                  .substring(0, 5));

  }

  React.useEffect(() => {
    if (!banksLoaded) {
      getBanks();
    } else if (ErrMessage === "Success") {
      navigation.navigate("CardsHome");
    } else if (ErrMessage != '') {
      navigation.navigate("CardsAddError");
    }
    }, [
      banksLoaded, ErrMessage
    ]);

  return (
    <ScrollView style={styles.scrollView}>
      <View style={GlobalStyles.containerNmax}>
        <View style={styles.headerContainer}>
          <View style={styles.backButtonContainer}>
            <StepBackButtonTopWhite />
          </View>
          <View style={styles.forwardButtonContainer}></View>
          <View style={styles.HbuttonBar}>
            <TouchableOpacity
              style={styles.HbackButtonStyle}
              activeOpacity={0.5}
              onPress={() => submitForm()}
            >
              <Text style={styles.TextStyleRight}>LINK</Text>
              <View style={styles.LinkBarNext}></View>
            </TouchableOpacity>
          </View>
        </View>
        <View style={styles.textHeaderContainer}>
          <Text style={styles.textStyleHeader}>Add new card</Text>
          <Text style={styles.TextStyleBody}>
            Verify Mastercard or Visa details allowing you to tap/pay with a
            registered card!
          </Text>
        </View>
        <View style={styles.bodyContainerFullAlert}>
          <View style={styles.boxContainerAlert}>
            <View style={GlobalStyles.formInputContainerInvest}>
              <Text style={GlobalStyles.formLabelTextInvest}>Card Number</Text>
              <View style={GlobalStyles.formInputBoxInvest}>
                <TextInput
                  placeholder="_ _ _ _   _ _ _ _    _ _ _ _    _ _ _ _"
                  style={GlobalStyles.textInputInvest}
                  underlineColorAndroid="transparent"
                  value={cardNo}
                  onChangeText={(text) => handleUpdateCardText(text)}
                  keyboardType="numeric"
                />
              </View>
              <Text style={styles.inputErrorText}>{cardNoErrorMessage}</Text>
            </View>
            <View style={GlobalStyles.formInputContainerInvest}>
              <Text style={GlobalStyles.formLabelTextInvest}>Expiry Date</Text>
              <View style={GlobalStyles.formInputBoxInvest}>
                <TextInput
                  placeholder="MM / YY"
                  style={GlobalStyles.textInputInvest}
                  underlineColorAndroid="transparent"
                  value={expiry}
                  onChangeText={(text) => handleUpdateExpiryText(text)}
                  keyboardType="numeric"
                />
              </View>
                <Text style={styles.inputErrorText}>{dateErrorMessage}</Text>
            </View>
            <Layout style={styles.dropDowncontainer}>
              {banksLoaded ?
                            <Select
                            size="large"
                            style={styles.selectStyleInvest}
                            placeholder="Card Provider"
                            onSelect={(index) => {
                              setSelectedID(banks[index-1].id);
                              setSelectedIndex(index-1);
                            }}
                            value={banks[selectedIndex].name}
                          >
                            {banks.map((bank,index) => {
                              return (
                                <SelectItem title={bank.name} key={'bankid'.concat(index)} />
                              )
                            })}
                          </Select>
                           : <></>}
            </Layout>
          </View>
        </View>
      </View>
    </ScrollView>
  );
}
const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
    backgroundColor: Colors.MIDBLUE,
  },
  headerContainer: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 25,
    paddingTop: 15,
    paddingLeft: 1,
    paddingRight: 25,
  },
  backButtonContainer: {
    flex: 1,
    // paddingTop: 50,
  },
  textHeaderContainer: {
    paddingLeft: 50,
    paddingRight: 50,
  },
  textStyleHeader: {
    color: Colors.WHITE,
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 22,
    width: "100%",
  },
  TextStyleBody: {
    color: Colors.WHITE,
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 14,
    lineHeight: 20,
    width: "100%",
    paddingTop: 10,
  },

  bodyContainerFullAlert: {
    paddingTop: 30,
    // paddingLeft: 35,
    // paddingRight: 35,
    width: "100%",
    paddingLeft: 30,
    paddingRight: 30,
  },
  boxContainerAlert: {
    flex: 1,
    alignContent: "center",
    backgroundColor: "#ffffff",
    justifyContent: "center",
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
    borderBottomLeftRadius: 15,
    maxWidth: 800,
    alignSelf: "center",
    paddingTop: 10,
    paddingBottom: 30,
    paddingLeft: 20,
    paddingRight: 20,
    marginBottom: 50,
    width: "100%",
  },
  dropDowncontainer: {
    marginTop: 15,
  },
  selectStyleInvest: {
    flex: 1,
    height: 50,
  },
  TextStyleRight: {
    color: "#ffffff",
    textAlign: "right",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    lineHeight: 14,
  },

  inputErrorText: {
    color: Colors.MIDBLUE,
    //textAlign: "right",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    lineHeight: 10,
    paddingTop: 5,
  },


  LinkBarNext: {
    width: "52%",
    height: 4,
    backgroundColor: "#FFC72C",
    alignSelf: "flex-end",
    marginTop: 10,
    marginBottom: 0,
  },
  HbackButtonStyle: {
    marginTop: 0,
    paddingTop: 5,
    paddingBottom: 5,
    width: 75,
  },
  HbuttonBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
  },
  bottonTextContainer: {
    flexDirection: "row",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 100,
  },
  footerText: {
    color: "#ffff",
    fontFamily: "montserrat-italic",
    textAlign: "center",
    fontSize: 12,
    lineHeight: 16,
    color: Colors.WHITE,
    paddingLeft: 5,
  },
});
